import { postProcessPrimeData } from './prime-core.js';

// ─── Constants ────────────────────────────────────────────────────────────────

const SEL = {
    seasons          : '.prime-stats-section .prime-filter-item select.prime-seasons',
    tournaments      : '.prime-stats-section .prime-filter-item select.prime-tournaments',
    teams            : '.prime-stats-section .prime-filter-item select.prime-teams',
    statsFilter      : '.prime-stats-section .prime-stats-filter',
    statsContainer   : '.prime-stats-container',
    statsSection     : '.prime-stats-section',
    dateFilterWrap   : '.date-filter-container',
    datepickerFrom   : '#datepicker_from',
    datepickerTo     : '#datepicker_to',
    searchSwitch     : '.search-switch-container button:not(.-is-active)',
    teamSwitch       : '.team-switch-container button:not(.-is-active)',
    matchExpander    : '.matchstats-expander',
    pageLink         : '.page-link-container',
    shareContainer   : '.share-container',
};

const CSS = {
    active    : '-is-active',
    loading   : '-is-loading',
    disabled  : '-is-disabled',
    pending   : '-is-pending',
};

window.bTheInitialLoading = false;  // global flag to indicate initial auto-trigger on page load – used to prevent disabling controls before the first auto-trigger runs


// ─── Date filter helpers ──────────────────────────────────────────────────────

/**
 * Disable the date filter inputs and mark the wrapper as disabled.
 */
function disableDateFilter() {
    $(SEL.dateFilterWrap).addClass(CSS.disabled).find('input').prop('disabled', 'disabled');
}

/**
 * Enable the date filter inputs and remove the disabled state from the wrapper.
 */
function enableDateFilter() {
    $(SEL.dateFilterWrap).removeClass(CSS.disabled).find('input').prop('disabled', false).removeProp('disabled');
}

/**
 * Clear both datepicker values and remove them from the global params object.
 */
function clearDateFilter() {
    window.oTheParams['date_from'] = null;
    window.oTheParams['date_to']   = null;
    $(SEL.datepickerFrom).val(null);
    $(SEL.datepickerTo).val(null);
}

// ─── Select helpers ───────────────────────────────────────────────────────────

/**
 * Reset a <select> element to a single placeholder option and disable it.
 * @param {string} selector  - jQuery selector for the <select>
 * @param {string} label     - Text for the placeholder option (value="0")
 */
function resetSelect(selector, label) {
    $(selector)
        .empty()
        .append(`<option value="0">${label}</option>`)
        .prop('selected', 'selected')
        .prop('disabled', 'disabled');
}

/**
 * Show a "please select a tournament" notice in the stats container.
 */
function showSelectTournamentNotice() {
    $(SEL.statsContainer).html('<h2>Vennligst velg turnering!</h2>');
}


// ─── AJAX helpers ─────────────────────────────────────────────────────────────

/**
 * Show a loading spinner in the stats container and disable the search button.
 * @param {jQuery} $btn - The search button element
 */
function showStatsLoading($btn) {
    $btn.prop('disabled', 'disabled');
    disableFilterControls();         
    $(SEL.statsContainer).empty().addClass(CSS.loading).append(window.sTheLoader);
}

/**
 * Re-enable the search button and clear the loading state from the stats container.
 * @param {jQuery} $btn - The search button element
 */
function hideStatsLoading($btn) {
    $(SEL.statsContainer).removeClass(CSS.loading);
    $btn.prop('disabled', false).removeProp('disabled');
    enableFilterControls();
}

/**
 * Standard success handler for a stats AJAX call.
 * Populates the stats container with the returned markup and post-processes it.
 * @param {jQuery} $btn - The search button element to re-enable
 * @returns {function} Callback suitable for window.Ajax.prime_v2
 */
function onStatsSuccess($btn) {
    return function(data) {
        $(SEL.statsContainer).html(data.markup).removeClass(CSS.loading);
        hideStatsLoading($btn);
        postProcessPrimeData($(data.param.container));
    };
}

/**
 * Standard error handler for a stats AJAX call.
 * @returns {function} Callback suitable for window.Ajax.prime_v2
 */
function onStatsError() {
    return function(data) { window.showError(data); };
}


let $enabledFilterControls = $();
/**
 * Disable all filter form elements during an AJAX request.
 */
function disableFilterControls() {
    
    
    if (window.bTheInitialLoading === true) {
        $enabledFilterControls = $();  // ← snapshot only what's currently enabled
    }
    else
    {
        $enabledFilterControls = $(SEL.seasons)
            .add(SEL.tournaments)
            .add(SEL.teams)
            .add(SEL.statsFilter)
            .add(SEL.datepickerFrom)
            .add(SEL.datepickerTo)
            .add('.search-switch-container button') 
            .add('.team-switch-container button')
            .filter(':not(:disabled)');  // ← snapshot only what's currently enabled

    }
    


    $enabledFilterControls.prop('disabled', 'disabled');

    console.log('Disabled filter controls:', $enabledFilterControls);
}


/**
 * Re-enable all filter form elements after an AJAX request completes.
 */

function enableFilterControls() {
    console.log('Filter controls to enable:', $enabledFilterControls);

    if (window.bTheInitialLoading == true) {
        
        $enabledFilterControls = $(SEL.seasons)
            .add(SEL.tournaments)
            .add(SEL.teams)
            .add(SEL.statsFilter)
            .add(SEL.datepickerFrom)
            .add(SEL.datepickerTo)
            .add('.search-switch-container button') 
            .add('.team-switch-container button');
    }

    $enabledFilterControls
        .prop('disabled', false)
        .removeProp('disabled');

    $enabledFilterControls = $();  // reset the snapshot
}

// ─── Query string builders ────────────────────────────────────────────────────

/**
 * Build the incidents query string for the current tournament.
 * @returns {string}
 */
function buildIncidentsQuery() {
    const tournamentId = $(SEL.statsSection).attr('data-tournament-id');
    return `tournaments/${tournamentId}/incidents/?usenif&size=1000`;
}

/**
 * Build a matches query string for either a team or a tournament,
 * with optional date range appended.
 * @param {number|string} teamId
 * @param {number|string} tournamentId
 * @param {string|null}   from  - Unix timestamp string, or null for full history
 * @param {string|null}   to    - Unix timestamp string, or null for full history
 * @returns {string}
 */
function buildMatchesQuery(teamId, tournamentId, from, to) {
    const fromStr = from !== null && from !== undefined ? from : '#$#START#$#';
    const toStr   = to   !== null && to   !== undefined ? to   : '#$#NOW#$#';
    const base    = teamId > 0
        ? `teams/${teamId}/matches/`
        : `tournaments/${tournamentId}/matches/`;
    return `${base}?size=500&from=${fromStr}&to=${toStr}&sort=desc&usenif`;
}

// ─── URL parameter helpers ────────────────────────────────────────────────────

/**
 * Update the browser URL params to reflect the current stats context,
 * unless a prime_context override is present in the URL.
 * @param {string}      type         - 'tournament' or 'team'
 * @param {number}      itemId       - Tournament or team ID
 * @param {number|null} tournamentId - Required when type is 'team'
 */
function syncUrlParams(type, itemId, tournamentId = null) {
    if (window.getUrlParameter('prime_context')) {
        window.setUrlParameter('prime_item_id', itemId);
        return;
    }
    window.removeUrlParameters();
    window.setUrlParameter('prime_type', type);
    if (itemId) window.setUrlParameter('prime_item_id', itemId);
    if (tournamentId) window.setUrlParameter('prime_tournament_id', tournamentId);
}

/**
 * Build and render the shareable page link for the current stats view.
 */
function renderShareLink() {
    const url = `${location.protocol}//${location.host}${location.pathname}`
        + `?prime_type=${window.sTheStatsQueryType}`
        + `&prime_item_id=${window.sTheStatsQueryId}`
        + (window.iTheStatsQueryTournament ? `&prime_tournament_id=${window.iTheStatsQueryTournament}` : '');

    const html = `<a href="${url}" class="prime-icon prime-share-icon d-flex justify-content-end align-items-center -has-font-weight-300">
        3.5,3.5c1.1,0,2.1-0.5,2.7-1.3l6,3.5c-0.2,0.4-0.3,0.8-0.3,1.3c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S19.9,15.5,18,15.5z"/></svg>Del</a>`;

    $(SEL.pageLink).html(html).closest(SEL.shareContainer).removeClass('d-none');
}

// ─── Datepickers ──────────────────────────────────────────────────────────────

/**
 * Wire up jQuery UI datepickers inside the stats and matches sections.
 * Each picker keeps the opposing picker's min/max date in sync and
 * writes the selected Unix timestamp into window.oTheParams.
 */
function initDatepickers() {
    if ($('.datepicker').length === 0) return;

    /**
     * Shared onSelect factory. Updates the sibling picker's boundary date
     * and stores the selected timestamp in window.oTheParams.
     * @param {string} siblingId    - ID of the opposing datepicker
     * @param {string} siblingProp  - 'minDate' or 'maxDate'
     * @param {string} paramKey     - Key to write into window.oTheParams
     */
    function makeDatepickerOnSelect(siblingId, siblingProp, paramKey) {
        return function(dateStr) {
            const [d, m, y] = dateStr.split('.');
            const date = new Date(y, m - 1, d);
            $(siblingId).datepicker('option', siblingProp, date);
            window.oTheParams[paramKey] = Math.floor(date.getTime() / 1000);
        };
    }

    const minStats = new Date(2017, 0, 1);
    const maxToday = '+1d';

    // Stats section — from
    $(`.prime-stats-section ${SEL.datepickerFrom}`).datepicker({
        minDate: minStats,
        maxDate: maxToday,
        onSelect: makeDatepickerOnSelect(SEL.datepickerTo, 'minDate', 'date_from'),
    });

    // Stats section — to
    $(`.prime-stats-section ${SEL.datepickerTo}`).datepicker({
        minDate: minStats,
        maxDate: maxToday,
        onSelect: makeDatepickerOnSelect(SEL.datepickerFrom, 'maxDate', 'date_to'),
    });

    // Matches section — from
    $(`.prime-matches-section ${SEL.datepickerFrom}`).datepicker({
        onSelect: makeDatepickerOnSelect(SEL.datepickerTo, 'minDate', 'date_from'),
    });

    // Matches section — to
    $(`.prime-matches-section ${SEL.datepickerTo}`).datepicker({
        onSelect: makeDatepickerOnSelect(SEL.datepickerFrom, 'maxDate', 'date_to'),
    });
}

// ─── Event handlers ───────────────────────────────────────────────────────────

/**
 * Toggle between "player stats" and "match stats" views.
 * Adjusts date filter availability based on which mode is active and
 * whether a tournament has been selected.
 */
function onSearchSwitchClick() {
    $('.search-switch-container button').removeClass(CSS.active);
    $(this).addClass(CSS.active);

    window.getStatsForMatches = $(this).hasClass('prime-matchstats-search-switch');

    if (!window.getStatsForMatches) {
        clearDateFilter();
        const teamSelected = $(SEL.teams).val() != 0;
        teamSelected ? disableDateFilter() : enableDateFilter();
    } else {
        enableDateFilter();
    }

    const tournamentSelected = $(SEL.tournaments).val() != 0;
    if (!tournamentSelected) {
        showSelectTournamentNotice();
        disableDateFilter();
    } else {
        $(SEL.statsFilter).trigger('click');
    }
}

/**
 * Toggle visibility between home and away team stat panels
 * within a match stats container.
 */
function onTeamSwitchClick() {
    const $container = $(this).closest('.team-switch-container');
    $container.find('button').removeClass(CSS.active);
    $(this).addClass(CSS.active);

    const $statsWrap = $(this).closest(SEL.statsContainer);
    const isHome     = $(this).hasClass('prime-home-switch');
    $statsWrap.find('.away').toggleClass('d-none',  isHome);
    $statsWrap.find('.home').toggleClass('d-none', !isHome);
}

/**
 * Handle season dropdown change.
 * Resets downstream selects (tournaments + teams), fetches tournaments
 * for the chosen season, and clears the stats panel.
 */
function onSeasonChange() {
    const $option     = $(this).find('option:selected');
    const container   = $option.attr('data-selector-container');

    $(container).empty().append('<option>&nbsp;...&nbsp;</option>');
    resetSelect(SEL.tournaments.split(' ').pop(), 'Velg turnering');
    resetSelect(SEL.teams.split(' ').pop(),       'Velg lag');

    $(SEL.statsSection).attr('data-season', $option.val());
    window.sTheStatsQueryType = 'season';
    window.sTheStatsQueryId   = $option.val();

    disableDateFilter();

    window.Ajax.prime_v2(
        {
            template   : $option.attr('data-selector-template'),
            id         : $option.val(),
            queryString: $option.attr('data-selector-query'),
            queryType  : $option.attr('data-query-type'),
            homeTeam   : $option.attr('data-home-team'),
            awayTeam   : $option.attr('data-away-team'),
            match      : $option.attr('data-match'),
            container  : container,
        },
        function(data) {
            $(container).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
            postProcessPrimeData($(data.param.container));
            showSelectTournamentNotice();
        },
        onStatsError()
    );
}

/**
 * Handle tournament dropdown change.
 * Resets the teams dropdown, fetches teams for the chosen tournament,
 * then auto-triggers the search button.
 * Shows a notice and disables date filters if "no tournament" is selected.
 */
function onTournamentChange() {
    const $option   = $(this).find('option:selected');
    const val       = $option.val();
    const container = $option.attr('data-selector-container');

    if (val == 0) {
        disableDateFilter();
        showSelectTournamentNotice();
        resetSelect(SEL.teams.split(' ').pop(), 'Velg lag');
        return;
    }

    $(container).empty().append('<option>&nbsp;...&nbsp;</option>');

    if ($('.prime-teams').length > 0) {
        resetSelect('.prime-teams', $('.prime-teams').attr('data-label') || 'Velg lag');
    }

    if ($(SEL.statsSection).attr('data-context') !== 'team') {
        $(SEL.statsSection).attr('data-tournament-id', val);
    }

    window.sTheStatsQueryType = 'tournament';
    window.sTheStatsQueryId   = val;

    disableDateFilter();
    syncUrlParams('tournament', val);

    // If returning to this page via a tournament context URL, auto-click search once
    if (window.bTheInitial === true && window.getUrlParameter('prime_context') === 'tournament') {
        $(SEL.statsFilter).click();
        const cleanUrl = window.location.href.replace('&prime_context=tournament', '');
        window.history.replaceState({}, document.title, cleanUrl);
        window.bTheInitial = false;
    }

    window.Ajax.prime_v2(
        {
            template   : $option.attr('data-selector-template'),
            id         : val,
            queryString: $option.attr('data-selector-query'),
            queryType  : $option.attr('data-query-type'),
            homeTeam   : $option.attr('data-home-team'),
            awayTeam   : $option.attr('data-away-team'),
            match      : $option.attr('data-match'),
            container  : container,
        },
        function(data) {
            $(container).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
            if (data.param) postProcessPrimeData($(data.param.container));
            enableDateFilter();
            $(SEL.statsFilter).click();
        },
        onStatsError()
    );
}

/**
 * Handle team dropdown change.
 * Updates the global query type to 'team' or falls back to 'tournament'
 * when "all teams" (value 0) is chosen, then triggers the search button.
 */
function onTeamChange() {
    const $option = $(this).find('option:selected');
    const teamId  = $option.val();

    if (teamId > 0) {
        window.sTheStatsQueryType       = 'team';
        window.sTheStatsQueryId         = teamId;
        window.iTheStatsQueryTournament = $('.prime-tournaments').find('option:selected').val();

        syncUrlParams('team', teamId, window.iTheStatsQueryTournament);

        if (window.bTheInitial === true) {
            $(SEL.statsSection).attr('data-team-id', teamId);
        }

        if (!window.getStatsForMatches) disableDateFilter();
    } else {
        window.sTheStatsQueryType = 'tournament';
        window.sTheStatsQueryId   = $('select.prime-tournaments').find('option:selected').val();

        if (window.bTheInitial === true) {
            $(SEL.statsSection).attr('data-team-id', 0);
        }

        enableDateFilter();
    }

    //alert('Team clicked');

    $(SEL.statsFilter).click();
}

/**
 * Handle the main search/filter button click.
 * Determines whether to fetch player stats or match stats,
 * with or without a date range, and renders the result.
 */
function onStatsFilterClick() {
    
    $(this).removeClass(CSS.pending);

    const $btn         = $(this);
    const dateFrom     = $(SEL.datepickerFrom).val();
    const dateTo       = $(SEL.datepickerTo).val();
    const teamId       = parseInt($('.prime-teams').find('option:selected').val())       || 0;
    const tournamentId = parseInt($('.prime-tournaments').find('option:selected').val()) || 0;

    renderShareLink();

    // Validate date range — both must be filled or neither
    if (dateFrom && !dateTo) { alert('Du må velge en til dato.'   + window.oTheParams['date_to']);   return; }
    if (!dateFrom && dateTo) { alert('Du må velge en fra dato.'   + window.oTheParams['date_from']); return; }

    const hasDateRange  = !!(dateFrom && dateTo);
    const fromParam     = hasDateRange ? window.oTheParams['date_from'] : null;
    const toParam       = hasDateRange ? window.oTheParams['date_to']   : null;

    showStatsLoading($btn);

    if (!window.getStatsForMatches && teamId) disableDateFilter();

    if (window.getStatsForMatches) {
        // ── Match stats mode ──────────────────────────────────────────────────
        window.Ajax.prime_v2(
            {
                template   : 'stats/statsmatches.php',
                id         : window.sTheStatsQueryId,
                queryString: buildMatchesQuery(teamId, tournamentId, fromParam, toParam),
                queryType  : 'stats_' + window.sTheStatsQueryType,
                container  : SEL.statsContainer,
            },
            onStatsSuccess($btn),
            onStatsError()
        );
    } else {
        // ── Player/team stats mode ────────────────────────────────────────────
        let queryString = buildIncidentsQuery();
        let queryType   = 'stats_' + window.sTheStatsQueryType;

        if (hasDateRange) {
            queryString += `&from=${fromParam}&to=${toParam}`;
            queryType   += '_periodized';
        } else {
            queryString += '&summarized=true';
        }

        window.Ajax.prime_v2(
            {
                template   : 'stats/table.php',
                id         : window.sTheStatsQueryId,
                queryString: queryString,
                queryType  : queryType,
                container  : SEL.statsContainer,
            },
            onStatsSuccess($btn),
            onStatsError()
        );
    }
}

/**
 * Handle click on a per-match stats expander row.
 * Toggles the stats panel and fetches match incident data if not yet loaded.
 */
function onMatchStatsExpanderClick() {
    const $expander       = $(this);
    const $loadedContainer = $expander.closest('.matchstats-wrapper').find(SEL.statsContainer);
    const matchId         = $expander.attr('data-id');

    $expander.toggleClass(CSS.active);
    $loadedContainer.toggleClass('d-none');

    window.Ajax.prime_v2(
        {
            template   : 'stats/table.php',
            id         : matchId,
            queryString: `matches/${matchId}/incidents/?usenif&size=1000`,
            queryType  : 'stats_matches',
            container  : '',
            homeTeam   : $expander.attr('data-hometeam'),
            awayTeam   : $expander.attr('data-awayteam'),
        },
        function(data) {
            $loadedContainer.empty().append(data.markup);
            if (data.param) postProcessPrimeData($loadedContainer);
        },
        onStatsError()
    );
}

/**
 * Handle click on the "Oppdater" cache-refresh button rendered inside PHP markup.
 * Re-fires the original prime_v2 call with refreshCache: true, bypassing the
 * server-side cache and replacing the nearest container with fresh content.
 */
function onRefreshCacheClick() {
    
    const $meta         = $(this).closest('.prime-cache-meta');
    const template      = $meta.attr('data-template');
    const container     = $meta.attr('data-container');
    const id            = $meta.attr('data-id');
    const queryString   = $meta.attr('data-querystring');
    const queryType     = $meta.attr('data-querytype');
    const $container    = $(container);

    $container.empty().addClass(CSS.loading).append(window.sTheLoader);

    window.Ajax.prime_v2(
        {
            template    : template,
            container   : container,
            refreshCache: true,
            id          : id,
            queryString : queryString,
            queryType   : queryType,
        },
        function(data) {
            $container.html(data.markup).removeClass(CSS.loading);
            postProcessPrimeData($container);
        },
        function(data) { window.showError(data); }
    );
}

// ─── Auto-trigger on page load ────────────────────────────────────────────────

/**
 * If the stats page was loaded with URL params (prime_type=team|tournament),
 * look up the matching season and trigger the season dropdown to cascade
 * selections automatically.
 */



function autoTriggerFromUrl() {
    if (!$('body').hasClass('page-template-template-stats')) return;

    const primeType = window.getUrlParameter('prime_type');

    //console.log (primeType);
    if (primeType !== 'team' && primeType !== 'tournament') return;

    const targetTournamentId = parseInt(
        window.getUrlParameter(primeType === 'team' ? 'prime_tournament_id' : 'prime_item_id')
    );

    console.log ('auto initialisation with tournament ID ' + targetTournamentId);

    window.Ajax.getNthData(
        {},
        function(data) {
            
            console.log (data);
            
            $.each(data.nthdata[0].seasons, function(_, season) {
                console.log (window.bTheInitialLoading);
                $.each(season.tournament, function(_, t) {
                    if (t.tournament_id === targetTournamentId) {
                        window.bTheInitialLoading = true;
                        $('.prime-seasons').val(season.season).change();
                    }
                });
            });
        },
        function() { return 0; }
    );
}

/**
 * If no prime_type URL param is present, auto-select the default season (2526)
 * to populate the tournament dropdown on first load.
 */
function autoTriggerDefaultSeason() {
    if (window.getUrlParameter('prime_type')) return;
    if ($('.prime-stats-section .prime-seasons.-is-ready option').length > 1) {
        $('.prime-stats-section .prime-seasons').val(2526).change().removeClass('-is-ready');
    }
}

// ─── Public init ─────────────────────────────────────────────────────────────

/**
 * Attach all stats filter event listeners and run startup triggers.
 * Call once on DOMContentLoaded / document ready.
 */
export function initStatsFilters() {
    window.getStatsForMatches = false;

    $(document).on('click',  SEL.searchSwitch,  onSearchSwitchClick);
    $(document).on('click',  SEL.teamSwitch,    onTeamSwitchClick);
    $(document).on('change', SEL.seasons,       onSeasonChange);
    $(document).on('change', SEL.tournaments,   onTournamentChange);
    $(document).on('change', SEL.teams,         onTeamChange);
    $(document).on('click',  SEL.matchExpander, onMatchStatsExpanderClick);
    $(document).on('click',  '.prime-refresh-cache', onRefreshCacheClick);

    $(SEL.statsFilter).on('click', onStatsFilterClick);

    autoTriggerFromUrl();
    autoTriggerDefaultSeason();
    initDatepickers();
}


// WEBPACK FOOTER //
// ./scripts/routes/common/prime-stats-filters.js